// @flow
import * as React from "react"
import { compose, withHandlers, type HOC } from "recompose"
import withOpen from "hoc/withOpen"
import withConnect from "hoc/withConnect"
import { openModal } from "data/modals/actions"
import Login from "modals/Login"
import SignUp from "modals/SignUp"
import LogoLink from "components/LogoLink"
import SearchAutocomplete from "../../LoggedInNav/SearchAutocomplete"
import { LeftWrap, RightWrap } from "./styled"
import { LogoWrap } from "./styled"
import { StyledNavLink } from "./styled"

const DesktopLoggedOutNav = ({ login, isOpen, open, close }) => (
  <React.Fragment>
    <LeftWrap>
      <LogoWrap>
        <LogoLink type="full" />
      </LogoWrap>
      <SearchAutocomplete
        initialValue=""
        isOpen={isOpen}
        open={open}
        close={close}
      />
    </LeftWrap>
    <RightWrap>
      <StyledNavLink onClick={login}>
        Log in
      </StyledNavLink>
    </RightWrap>
  </React.Fragment>
)

const mapDispatchToProps = {
  openModal,
}

const enhancer: HOC<*, {||}> = compose(
  withOpen,
  withConnect(() => ({}), mapDispatchToProps),
  withHandlers({
    register: props => () => props.openModal(SignUp, {}),
    login: props => () => props.openModal(Login, {}),
  }),
)
export default enhancer(DesktopLoggedOutNav)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedOutNav/DesktopLoggedOutNav/index.js